import httpClient from './httpClient';

export interface CatalogItemDto {
  id: string;
  typeCode: string;
  parentId?: string | null;
  ownerId?: string | null;
  dataJson: string;
}

export interface CatalogItemPage {
  items: CatalogItemDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface CreateCatalogItemRequest {
  typeCode: string;
  dataJson: string;
  parentId?: string | null;
  ownerId?: string | null;
}

export interface UpdateCatalogItemRequest {
  dataJson: string;
  parentId?: string | null;
  ownerId?: string | null;
}

export const catalogItemsApi = {
  async list(acqTypeCode: string, acqParams: {
    parentId?: string;
    ownerId?: string;
    search?: string;
    page?: number;
    pageSize?: number;
  } = {}): Promise<CatalogItemPage> {
    const acqQuery: Record<string, unknown> = { qTypeCode: acqTypeCode };
    if (acqParams.parentId) acqQuery.qParentId = acqParams.parentId;
    if (acqParams.ownerId) acqQuery.qOwnerId = acqParams.ownerId;
    if (acqParams.search) acqQuery.qSearch = acqParams.search;
    if (acqParams.page) acqQuery.qPage = acqParams.page;
    if (acqParams.pageSize) acqQuery.qPageSize = acqParams.pageSize;
    const acqRes = await httpClient.get<CatalogItemPage>('/catalog-items', { params: acqQuery });
    return acqRes.data;
  },

  async getById(acqId: string): Promise<CatalogItemDto> {
    const acqRes = await httpClient.get<CatalogItemDto>(`/catalog-items/${acqId}`);
    return acqRes.data;
  },

  async create(acqReq: CreateCatalogItemRequest): Promise<string> {
    const acqRes = await httpClient.post<string>('/catalog-items', acqReq);
    return acqRes.data;
  },

  async update(acqId: string, acqReq: UpdateCatalogItemRequest): Promise<void> {
    await httpClient.put(`/catalog-items/${acqId}`, acqReq);
  },

  async delete(acqId: string): Promise<void> {
    await httpClient.delete(`/catalog-items/${acqId}`);
  },
};
